<template>
  <div>
    <!-- 弃用 -->
    <!-- 合世物流承运商结算单 -->
    <!--  打印预览-->
    <myDialog
      :diaWidth="diaWidth_print"
      :dialogTitle="dialogTitle_print"
      :isShowDialog="isShowDialog_print"
      confirmText="打印"
      @handleCloseDia="handleCloseDia_print"
      @diaCancelBtn="handleCloseDia_print"
      @diaConfirmBtn="diaConfirmBtn_print()"
    >
      <div ref="print" id="printBill" style="color: #000">
        <div style="position: relative">
          <div
            style="
              text-align: center;
              font-size: 22px;
              font-weight: 700;
              height: 58px;
              line-height: 58px;
            "
          >
            {{ printTit }}
          </div>
          <div
            style="
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
            "
          >
            <div>打印日期: {{ cTime }}</div>
            <div>刘诗诗</div>
            <!-- <div>第1页,共1页</div> -->
          </div>
        </div>
        <div
          style="
            display: flex;
            flex-wrap: wrap;
            font-size: 14px;
            font-weight: 700;
          "
        >
          <div style="margin-right: 20px; margin-bottom: 6px">
            应收总额: {{ topData.number || "暂无" }},
          </div>
          <div style="margin-right: 20px; margin-bottom: 6px">
            应付总额: {{ topData.carType || "暂无" }},
          </div>
          <div style="margin-right: 20px; margin-bottom: 6px">
            结算余额: {{ topData.loadableCapacity || "暂无" }},
          </div>
        </div>
        <!-- <div>
          制单日期: <span>从: 2022-10-11</span>
          <span style="margin-left: 30px">至: 2022-12-12</span>
        </div> -->
        <!-- 表格 -->
        <table
          style="
            width: 100%;
            border: 1px solid #666;
            margin-top: 10px;
            border-collapse: collapse;
            font-size: 14px;
            box-sizing: border-box;
          "
        >
          <thead>
            <tr style="text-align: center">
              <th
                style="border: 1px solid #666"
                v-for="item in tableHeardList"
                :key="item.field"
              >
                {{ item.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              style="text-align: center"
              v-for="(item, idx) in tableList"
              :key="idx"
            >
              <td style="border: 1px solid #666; word-break: break-all">
                {{ idx + 1 }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 任务编号 -->
                {{ item.number }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 运单号 -->
                {{ item.waybillNumber }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 货物名称 -->
                {{ item.goodsName }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 品类 -->
                {{ item.itemCategoryName }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 包装 -->
                {{ item.packageName }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 件数 -->
                {{ item.packageCout }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 毛重 -->
                {{ item.grossWeight }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 净重 -->
                {{ item.netWeight }}
              </td>
              <!-- 计费取值 -->
              <!-- <td style="border: 1px solid #666; word-break: break-all">
                {{ item.billingWeight }}
              </td> -->
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 体积 -->
                {{ item.volume }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 规格 -->
                {{ item.specs }}
              </td>
              <td style="border: 1px solid #666; word-break: break-all">
                <!-- 开单备注 -->
                {{ item.remarks }}
              </td>
            </tr>
          </tbody>
        </table>

        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
          "
        >
          <div class="items_btns" style="width: 20%">
            <div>批准:</div>
            <div>批准日期:</div>
          </div>
          <div class="items_btns" style="width: 20%">
            <div>审核人:</div>
            <div>审核日期:</div>
          </div>
          <div class="items_btns" style="width: 20%">
            <div>会计:</div>
            <div>日期:</div>
          </div>
          <div class="items_btns" style="width: 20%">
            <div>出纳:</div>
            <div>日期:</div>
          </div>
          <div class="items_btns" style="width: 20%">
            <div>经手人:</div>
            <div>日期:</div>
          </div>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
export default {
  components: { myDialog },
  props: {
    isShowDialog_print: {
      typeof: Boolean,
      default: false,
    },
    dialogTitle_print: {
      typeof: String,
      default: "",
    },
    diaWidth_print: {
      typeof: String,
      default: "90%",
    },
    dataList: {
      typeof: Array,
      default: [],
    },
    topData: {
      typeof: Object,
      default: {},
    },
  },
  data() {
    return {
      tableHeardList: [
        {
          name: "序号",
          field: "idx",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "中转日期",
          field: "outgoingTime",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "发货人",
          field: "takeContacts",
          width: "180",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "中转单号",
          field: "outgoingNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },

        {
          name: "运单号",
          field: "waybillNumber",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "承运商",
          field: "outboundCarrierName",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "目的地",
          field: "destAddress",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费方式",
          field: "billingMethod",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCount",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "重量",
          field: "weight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "单价",
          field: "aaaaaa",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "中转运费",
          field: "basicFreight",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "中转送货费",
          field: "aaaaaa",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "中转其他",
          field: "aaaaaa",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "合计",
          field: "aaaaaa",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "应收全额",
          field: "aaaaaa",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "付款方式",
          field: "settlementMethod",
          width: "120",
          sort: 1,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      tableList: [],
      cTime: "",
      printTit: "合世物流承运商结算单",
    };
  },
  watch: {
    dataList(a, b) {
      console.log("dataList", a);
      this.tableList = a;
    },
    topData(a, b) {
      console.log("topData", a);
    },
  },
  created() {},
  mounted() {},
  activated() {
    this.cTime = this.$TOOLS.getCurrentTime();
  },
  destroyed() {},
  methods: {
    // 打印预览弹窗
    diaConfirmBtn_print() {
      // this.$emit("diaConfirmBtn_print");

      let that = this;
      setTimeout(() => {
        that.$print(this.$refs.print);
      }, 10);
    },
    handleCloseDia_print() {
      this.$emit("handleCloseDia_print");
    },
  },
};
</script>
<style scoped lang='less'>
// 打印预览的样式
@media print {
  // 去掉页眉页脚
  @page {
    margin: 0 10mm;
  }
}
.aaa {
}
</style>